import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { THEME_SETTINGS } from "@theme-settings";
import { getRedirectOriginUrl } from "@utils/specific/capacitor/helpers";
import { Button } from "@components/buttons";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { useRootAppStore } from "@hooks";
import { useFixBody } from "@state/hooks/shared";

export default observer(function ShareBetSlipModal() {
	const store = useContext(MyBetsStoreContext);
	const rootStore = useRootAppStore();

	const { t } = useTranslation("mybets");
	useFixBody(false, store?.shareBetSlipStore.isActive, "reuse-form");

	if (!THEME_SETTINGS.features.isBetSlipShareEnabled) {
		return null;
	}

	if (store == null) {
		return null;
	}

	const sharedBetSlip = store.shareBetSlipStore.activeSharedBetSlip;

	if (!store.shareBetSlipStore.isActive || !sharedBetSlip) {
		return null;
	}

	return (
		<div
			id="reuse-form"
			className="popup popup--share"
			data-at="at-ShareBetSlipModal"
		>
			<div className="popup__card">
				<div className="popup__header">
					<div className="popup__title">
						{t("SHARE.BUTTON_LABEL")}
					</div>
					<Button
						type="button"
						onClick={() => store.shareBetSlipStore.hidePopup()}
						className="btn--square btn--square--sml btn--ghost popup__close"
						iconOnly={true}
						iconClassName="u-icon--tny u-icon--close u-color--text--secondary"
					/>
				</div>
				<div className="popup__body popup__body--spaced">
					<div className="popup--share__row">
						<div className="popup--share__item">
							<a
								href={`https://api.whatsapp.com/send?text=${getRedirectOriginUrl(
									`/bet-slip-shared/${sharedBetSlip.betSlipNumber}`
								)}`}
								data-action="share/whatsapp/share"
								target="_blank"
								className="popup--share__btn--whatsapp btn btn--round btn--round--base btn--icon"
								onClick={() => {
									store.shareBetSlipStore.insertSharedBetSlip();
								}}
							>
								<i className="u-icon u-icon--base u-icon--whatsapp u-color--core--snow" />
							</a>
							<span className="popup--share__label">
								WhatsApp
							</span>
						</div>
						<div className="popup--share__item">
							<a
								href={`viber://forward?text=${getRedirectOriginUrl(
									`/bet-slip-shared/${sharedBetSlip.betSlipNumber}`
								)}`}
								target="_blank"
								className="popup--share__btn--viber btn btn--round btn--round--base btn--icon"
								onClick={() => {
									store.shareBetSlipStore.insertSharedBetSlip();
								}}
							>
								<i className="u-icon u-icon--med u-icon--viber u-color--core--snow" />
							</a>
							<span className="popup--share__label">Viber</span>
						</div>
						<div className="popup--share__item">
							<a
								className="popup--share__btn--email btn btn--round btn--round--base btn--icon"
								href={`mailto:?subject=Bet%20slip&body=${getRedirectOriginUrl(
									`/bet-slip-shared/${sharedBetSlip.betSlipNumber}`
								)}`}
								title="Share by Email"
								onClick={() => {
									store.shareBetSlipStore.insertSharedBetSlip();
								}}
							>
								<i className="u-icon u-icon--med u-icon--email--str u-color--core--snow" />
							</a>
							<span className="popup--share__label">Email</span>
						</div>
						{WEBPACK_IS_CHAT_AVAILABLE && (
							<div className="popup--share__item">
								<button
									className="popup--share__btn--chat btn btn--round btn--round--base btn--icon"
									title="Share to Chat"
									onClick={() => {
										rootStore.chatViewStore.openBetSlipMessagePreview(
											sharedBetSlip
										);
										store.shareBetSlipStore.hidePopup();
									}}
								>
									<i className="u-icon u-icon--med u-icon--sml--responsive u-icon--chat--str u-color--core--snow"></i>
								</button>
								<span className="popup--share__label">
									Chat
								</span>
							</div>
						)}
					</div>
				</div>
				<div className="popup__footer popup--share__footer">
					<div className="popup--share__copy">
						<i className="u-icon u-icon--base u-icon--hyperlink" />
						<span className="popup--share__copy__label">
							{getRedirectOriginUrl(
								`/bet-slip-shared/${sharedBetSlip.betSlipNumber}`
							)}
						</span>
						<button
							className="popup--share__copy__btn btn btn--sml btn--accent"
							type="button"
							onClick={() => {
								store.shareBetSlipStore.copyLink();
							}}
						>
							{t("SHARE.COPY_LINK")}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
});
